// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientComp_clientCompMainOuter__19LLY {
    width: 100%;
    background-color: #d3cfd000;
    padding: 20px;
    position: relative;

}

.clientComp_clientBackgroundStatic__GvsaE {
    padding: 50px;
    z-index: 0;
    height: 700px;
    width: 100%;
}

.clientComp_clientCompConten__QgUuR {
    position: relative;
    z-index: 1;
}

.clientComp_clientHeaderBox__c3yuI {
    text-align: center;
    margin-bottom: 20px;
}

.clientComp_clientHeaderTxt__WrpnO {
    font-size: 3rem;
    font-family: "Livvic", serif;
    font-weight: 700;
    font-style: normal;
    margin: 50px 0px;
}

.clientComp_clientCardMainSwiper__13cus {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.clientComp_clientPaper1__869Q-,
.clientComp_clientPaper3__Aod6t,
.clientComp_clientPaper2__rhgAD {
    width: 30%;
    height: 70vh;
    align-items: center;
    text-align: center;
    box-shadow: none;
    background-color: rgba(255, 235, 205, 0);

}

.clientComp_clientLogoCont__yR\\+mA {
    height: 300px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    text-align: center;
    justify-content: center;
}

.clientComp_clientLogo__hbxcZ {
    width: 150px;
    margin: 10px;
}

.clientComp_clientLogoSqr__wKJP5 {
    width: 100px;
    margin: 10px;
}

.clientComp_clientCountryText__6KpC5 {
    visibility: visible;
    font-weight: 800;
    margin: 20px;
    color: #353535;
    /* opacity: 0; */
}

/* .clientPaper1:hover .clientCountryText {
    visibility: visible;
    animation-name: example;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
} */

/* .clientPaper2:hover .clientCountryText {
    visibility: visible;
    animation-name: example;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
} */

/* .clientPaper3:hover .clientCountryText {
    visibility: visible;
    animation-name: example;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
} */
.clientComp_clientPaper1__869Q-:hover .clientComp_clientLogo__hbxcZ{
    animation-name: clientComp_LogoAnimation__JmZvk;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
}
.clientComp_clientPaper2__rhgAD:hover .clientComp_clientLogo__hbxcZ{
    animation-name: clientComp_LogoAnimation__JmZvk;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
}
.clientComp_clientPaper3__Aod6t:hover .clientComp_clientLogoSqr__wKJP5{
    animation-name: clientComp_LogoAnimation2__\\+VRH0;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
}
.clientComp_clientPaper3__Aod6t:hover .clientComp_clientLogo__hbxcZ{
    animation-name: clientComp_LogoAnimation__JmZvk;
    animation-duration: 1s;
    position: relative;
    animation-timing-function: ease;
    animation-fill-mode: forwards;
}
/* @keyframes example {
    0% {
        top: 50px;
        opacity: 0;
    }

    100% {
        top: 0px;
        opacity: 1;
    }
} */
@keyframes clientComp_LogoAnimation__JmZvk {
    0% {
        width: 150px;

    }

    100% {
        width: 160px;
    }
}

@keyframes clientComp_LogoAnimation2__\\+VRH0 {
    0% {
        width: 100px;

    }

    100% {
        width: 110px;
    }
}
@keyframes clientComp_LogoAnimationHover__VpULR {
    0% {
        width: 100px;

    }

    100% {
        width: 110px;
    }
}

@keyframes clientComp_LogoAnimation2Hover__9DUQJ {
    0% {
        width: 80px;

    }

    100% {
        width: 90px;
    }
}
@media (max-width:1024px){
    .clientComp_clientLogo__hbxcZ {
        width: 100px;
        margin: 10px;
    }
    
    .clientComp_clientLogoSqr__wKJP5 {
        width: 80px;
        margin: 10px;
    }
    .clientComp_clientCountryText__6KpC5 {
       font-size: 18px;
    }
    .clientComp_clientPaper1__869Q-:hover .clientComp_clientLogo__hbxcZ{
        animation-name: clientComp_LogoAnimationHover__VpULR;
    }
    .clientComp_clientPaper2__rhgAD:hover .clientComp_clientLogo__hbxcZ{
        animation-name: clientComp_LogoAnimationHover__VpULR;
    }
    .clientComp_clientPaper3__Aod6t:hover .clientComp_clientLogoSqr__wKJP5{
        animation-name: clientComp_LogoAnimation2Hover__9DUQJ;
    }
}
@media (max-width:770px){
    .clientComp_clientBackgroundStatic__GvsaE{
        padding: 30px ;
    }
    .clientComp_clientHeaderTxt__WrpnO {
        font-size: 2rem;
        font-weight: 600;
    }
    .clientComp_clientBodyTxt__B64\\+E{
        font-size: 16px;
        font-weight: 400;
    }
}
@media (max-width:480px){
    .clientComp_clientBackgroundStatic__GvsaE{
        padding: 30px 0px 30px 0px ;
    }

    .clientComp_clientLogo__hbxcZ {
        width: 75px;
        margin: 10px;
    }
    
    .clientComp_clientLogoSqr__wKJP5 {
        width: 65px;
        margin: 10px;
    }
    .clientComp_clientCountryText__6KpC5 {
       font-size: 14px;
    }
    .clientComp_clientPaper1__869Q-:hover .clientComp_clientLogo__hbxcZ{
        animation-name: clientComp_LogoAnimationHover__VpULR;
    }
    .clientComp_clientPaper2__rhgAD:hover .clientComp_clientLogo__hbxcZ{
        animation-name: clientComp_LogoAnimationHover__VpULR;
    }
    .clientComp_clientPaper3__Aod6t:hover .clientComp_clientLogoSqr__wKJP5{
        animation-name: clientComp_LogoAnimation2Hover__9DUQJ;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/home/clientComp.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;IAGI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;;AAE5C;;AAEA;IACI,aAAa;IACb,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;;;;;;;GAOG;;AAEH;;;;;;;GAOG;;AAEH;;;;;;;GAOG;AACH;IACI,+CAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;AACjC;AACA;IACI,+CAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;AACjC;AACA;IACI,iDAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;AACjC;AACA;IACI,+CAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;AACjC;AACA;;;;;;;;;;GAUG;AACH;IACI;QACI,YAAY;;IAEhB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;;IAEhB;;IAEA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;;IAEhB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;;IAEf;;IAEA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;OACG,eAAe;IAClB;IACA;QACI,oDAAkC;IACtC;IACA;QACI,oDAAkC;IACtC;IACA;QACI,qDAAmC;IACvC;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;OACG,eAAe;IAClB;IACA;QACI,oDAAkC;IACtC;IACA;QACI,oDAAkC;IACtC;IACA;QACI,qDAAmC;IACvC;AACJ","sourcesContent":[".clientCompMainOuter {\r\n    width: 100%;\r\n    background-color: #d3cfd000;\r\n    padding: 20px;\r\n    position: relative;\r\n\r\n}\r\n\r\n.clientBackgroundStatic {\r\n    padding: 50px;\r\n    z-index: 0;\r\n    height: 700px;\r\n    width: 100%;\r\n}\r\n\r\n.clientCompConten {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.clientHeaderBox {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.clientHeaderTxt {\r\n    font-size: 3rem;\r\n    font-family: \"Livvic\", serif;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    margin: 50px 0px;\r\n}\r\n\r\n.clientCardMainSwiper {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.clientPaper1,\r\n.clientPaper3,\r\n.clientPaper2 {\r\n    width: 30%;\r\n    height: 70vh;\r\n    align-items: center;\r\n    text-align: center;\r\n    box-shadow: none;\r\n    background-color: rgba(255, 235, 205, 0);\r\n\r\n}\r\n\r\n.clientLogoCont {\r\n    height: 300px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n}\r\n\r\n.clientLogo {\r\n    width: 150px;\r\n    margin: 10px;\r\n}\r\n\r\n.clientLogoSqr {\r\n    width: 100px;\r\n    margin: 10px;\r\n}\r\n\r\n.clientCountryText {\r\n    visibility: visible;\r\n    font-weight: 800;\r\n    margin: 20px;\r\n    color: #353535;\r\n    /* opacity: 0; */\r\n}\r\n\r\n/* .clientPaper1:hover .clientCountryText {\r\n    visibility: visible;\r\n    animation-name: example;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n} */\r\n\r\n/* .clientPaper2:hover .clientCountryText {\r\n    visibility: visible;\r\n    animation-name: example;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n} */\r\n\r\n/* .clientPaper3:hover .clientCountryText {\r\n    visibility: visible;\r\n    animation-name: example;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n} */\r\n.clientPaper1:hover .clientLogo{\r\n    animation-name: LogoAnimation;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n}\r\n.clientPaper2:hover .clientLogo{\r\n    animation-name: LogoAnimation;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n}\r\n.clientPaper3:hover .clientLogoSqr{\r\n    animation-name: LogoAnimation2;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n}\r\n.clientPaper3:hover .clientLogo{\r\n    animation-name: LogoAnimation;\r\n    animation-duration: 1s;\r\n    position: relative;\r\n    animation-timing-function: ease;\r\n    animation-fill-mode: forwards;\r\n}\r\n/* @keyframes example {\r\n    0% {\r\n        top: 50px;\r\n        opacity: 0;\r\n    }\r\n\r\n    100% {\r\n        top: 0px;\r\n        opacity: 1;\r\n    }\r\n} */\r\n@keyframes LogoAnimation {\r\n    0% {\r\n        width: 150px;\r\n\r\n    }\r\n\r\n    100% {\r\n        width: 160px;\r\n    }\r\n}\r\n\r\n@keyframes LogoAnimation2 {\r\n    0% {\r\n        width: 100px;\r\n\r\n    }\r\n\r\n    100% {\r\n        width: 110px;\r\n    }\r\n}\r\n@keyframes LogoAnimationHover {\r\n    0% {\r\n        width: 100px;\r\n\r\n    }\r\n\r\n    100% {\r\n        width: 110px;\r\n    }\r\n}\r\n\r\n@keyframes LogoAnimation2Hover {\r\n    0% {\r\n        width: 80px;\r\n\r\n    }\r\n\r\n    100% {\r\n        width: 90px;\r\n    }\r\n}\r\n@media (max-width:1024px){\r\n    .clientLogo {\r\n        width: 100px;\r\n        margin: 10px;\r\n    }\r\n    \r\n    .clientLogoSqr {\r\n        width: 80px;\r\n        margin: 10px;\r\n    }\r\n    .clientCountryText {\r\n       font-size: 18px;\r\n    }\r\n    .clientPaper1:hover .clientLogo{\r\n        animation-name: LogoAnimationHover;\r\n    }\r\n    .clientPaper2:hover .clientLogo{\r\n        animation-name: LogoAnimationHover;\r\n    }\r\n    .clientPaper3:hover .clientLogoSqr{\r\n        animation-name: LogoAnimation2Hover;\r\n    }\r\n}\r\n@media (max-width:770px){\r\n    .clientBackgroundStatic{\r\n        padding: 30px ;\r\n    }\r\n    .clientHeaderTxt {\r\n        font-size: 2rem;\r\n        font-weight: 600;\r\n    }\r\n    .clientBodyTxt{\r\n        font-size: 16px;\r\n        font-weight: 400;\r\n    }\r\n}\r\n@media (max-width:480px){\r\n    .clientBackgroundStatic{\r\n        padding: 30px 0px 30px 0px ;\r\n    }\r\n\r\n    .clientLogo {\r\n        width: 75px;\r\n        margin: 10px;\r\n    }\r\n    \r\n    .clientLogoSqr {\r\n        width: 65px;\r\n        margin: 10px;\r\n    }\r\n    .clientCountryText {\r\n       font-size: 14px;\r\n    }\r\n    .clientPaper1:hover .clientLogo{\r\n        animation-name: LogoAnimationHover;\r\n    }\r\n    .clientPaper2:hover .clientLogo{\r\n        animation-name: LogoAnimationHover;\r\n    }\r\n    .clientPaper3:hover .clientLogoSqr{\r\n        animation-name: LogoAnimation2Hover;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clientCompMainOuter": `clientComp_clientCompMainOuter__19LLY`,
	"clientBackgroundStatic": `clientComp_clientBackgroundStatic__GvsaE`,
	"clientCompConten": `clientComp_clientCompConten__QgUuR`,
	"clientHeaderBox": `clientComp_clientHeaderBox__c3yuI`,
	"clientHeaderTxt": `clientComp_clientHeaderTxt__WrpnO`,
	"clientCardMainSwiper": `clientComp_clientCardMainSwiper__13cus`,
	"clientPaper1": `clientComp_clientPaper1__869Q-`,
	"clientPaper3": `clientComp_clientPaper3__Aod6t`,
	"clientPaper2": `clientComp_clientPaper2__rhgAD`,
	"clientLogoCont": `clientComp_clientLogoCont__yR+mA`,
	"clientLogo": `clientComp_clientLogo__hbxcZ`,
	"clientLogoSqr": `clientComp_clientLogoSqr__wKJP5`,
	"clientCountryText": `clientComp_clientCountryText__6KpC5`,
	"LogoAnimation": `clientComp_LogoAnimation__JmZvk`,
	"LogoAnimation2": `clientComp_LogoAnimation2__+VRH0`,
	"LogoAnimationHover": `clientComp_LogoAnimationHover__VpULR`,
	"LogoAnimation2Hover": `clientComp_LogoAnimation2Hover__9DUQJ`,
	"clientBodyTxt": `clientComp_clientBodyTxt__B64+E`
};
export default ___CSS_LOADER_EXPORT___;
